<div class="flexbox">
	<img [src]="aoMaintenanceImgUrl" alt="Maintenance Auto Owners Logo" class="maintenance-image" />
	<div>
		<h1 class="ao-orange ao-heading-100 ao-bottom-24 error-heading">We are down for scheduled maintenance.</h1>
		<p class="ao-bottom-16">Sorry for the inconvenience - we'll be back up shortly.</p>
		<p>Do you want to try one of these instead?</p>
		<ul>
			<li><a href="/track-a-claim">Track a Claim</a></li>
			<li><a href="https://www.auto-owners.com/" target="_self">Home</a></li>
		</ul>
	</div>
</div>
